// Module
var code = `<div class="js-tabStrip">
    {{#each items:mindex}}
    <div class="tabStrip-item" {{^.visible}}style="display: none;" {{/}} on-click="['tabStripItem', mindex]" {{#.active}}active="" {{/}} {{#.enabled}}enabled="" {{/}}>
        <div class="tabStrip-itemText" on-dblclick="['tabStripDoubleClick', mindex]"> {{.text}} </div>

        <div class="tabStrip-itemLock" on-click="['tabStripLockItem', mindex]" {{#.locked}}locked="" {{/}} {{^~/allowUserEdit}}style="visibility:hidden" {{/}}>
            <svg>
                {{#if .locked}}
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#tabStripItemLocked"></use>
                {{else}}
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#tabStripItemUnlocked"></use>
                {{/if}}
            </svg>
        </div>

        <terceraButton name="morePanelActionsBtn" 
            SVG="true" 
            terceraButtonStyle="tabStrip-ShowMoreActionMenu" 
            visible="{{allowMoreActionMenu}}"
            on-btnClick="@this.tabStripShowMoreActionMenu(event)"
            enabled="{{isCanChangeWorkspaces}}"/>

        <div class="tabStrip-deleteItem {{#.locked}}tabStrip-deleteItem-none{{/}}" on-click="['tabStripDeleteItem', mindex]" {{^~/allowCloseTab}}style="visibility:hidden" {{/}}>
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#closeCrossBtn"></use>
            </svg>
        </div>
    </div>

    <div class="tabStrip-separator" {{^.visible}}style="display: none;" {{/}}></div>
    {{/each}}
    <div class="tabStrip-buttons">
        <terceraButton  name="viewMoreHorizontal" 
            SVG="true" 
            terceraButtonStyle="tabStrip-ShowMoreTabs"
            visible="{{.showMoreItem}}" 
            on-btnClick="@this.showMoreTabs(event)"
            checked="{{isMoreMenuOpen}}"
            enabled="{{isCanChangeWorkspaces}}"/>
        
        {{#if .allowAddNewTab && isCanChangeWorkspaces}}
        <div class="tabStrip-add-new-item" on-click="tabStripNewItem">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#add"></use>
            </svg>
        </div>
        {{/if}}
    </div>
    <terceraLinkLabel linkHref="{{poweredByURL}}" text="{{poweredByText}}" visible="{{poweredByVisible}}" />
</div>`;
// Exports
export default code;